import setupIsotope from '../util/setupIsotope';
import setupInsightSwiper from '../util/setupInsightSwiper';
import AOS from 'aos';
import Vivus from 'vivus';
import Swiper from 'swiper';

const siedlungSingle = function () {
  console.log('hello from siedlung-single');

  let vivusInstances = {};

  setTimeout(function () {
    setupIsotope();
    setupInsightSwiper();
    AOS.init();
    initVivusInstances();
    addAOSEventListener();
    setupGemeinschaftsraumSwiper();
  }, 500);

  function addAOSEventListener() {
    console.log('add event listeners');
    document.addEventListener('aos:in', ({ detail }) => {
      var svgId = $(detail).find('svg.animated-svg').attr('id');
      vivusInstances[svgId].play();
    });

    document.addEventListener('aos:out', ({ detail }) => {
      var svgId = $(detail).find('svg.animated-svg').attr('id');
      vivusInstances[svgId].reset();
    });
  }

  function initVivusInstances() {
    $('svg.animated-svg').each(function () {
      const svgId = $(this).attr('id');
      const vivus = new Vivus(
        svgId,
        {
          type: 'sync',
          start: 'manual',
          duration: 50,
          animTimingFunction: Vivus.EASE,
        },
        function () {
          console.log('played svg for ' + svgId);
        }
      );

      vivusInstances[svgId] = vivus;
    });
  }

  function setupGemeinschaftsraumSwiper() {
    if ($('.swiper-container.gemeinschaftsraum').length) {
      // Swiper on top
      let swiper = new Swiper('.swiper-container.gemeinschaftsraum', {
        speed: 400,
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        init: true,
        autoplay: {
          delay: 3000,
        },
        lazy: {
          loadPrevNext: true,
        },
      });

      swiper.update();
    }
  }
};

export default siedlungSingle;



// WEBPACK FOOTER //
// ./scripts/barba-views/siedlung-single.js